import { render, staticRenderFns } from "./LdpOrder.vue?vue&type=template&id=40300791&scoped=true"
import script from "./LdpOrder.vue?vue&type=script&lang=js"
export * from "./LdpOrder.vue?vue&type=script&lang=js"
import style0 from "./LdpOrder.vue?vue&type=style&index=0&id=40300791&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40300791",
  null
  
)

export default component.exports